module.exports = __webpack_public_path__ + "img/fashion_93.01231c8d.jpg";